import React from "react";
import {
    traducirPagina
} from "../../librerias/funciones"
import { Timeline, Drawer } from 'antd';
import {
    ShoppingOutlined,
    DeleteOutlined,
    ClockCircleOutlined,
    CloseOutlined
} from '@ant-design/icons';


export const HistorialData = (props) => {


    const CREAR_LISTA = (LISTA) => {
        let LISTA_FINAL = []
        let DATA = []

        if (LISTA !== null && LISTA.length > 0) {

            switch (props.ESTADO.TIPO_ORIGEN) {
                case "CONTROL_LITE":
                    DATA = LISTA
                    break;
                case "NEXT_DATA":
                    //5 BASIC, 4 MANUALES, 1 VERSION
                    DATA = LISTA.filter((item) => item.ID_VERSION === props.ESTADO.ID_VERSION)
                    break;
                default:

            }


            if (DATA.length > 0) {
                DATA.map((registro, i) => {

                    if (registro.FECHA_BAJA !== "") {
                        LISTA_FINAL.push({ position: 'left', dot: <DeleteOutlined style={{ fontSize: '22px', color: 'red' }} />, children: <div style={{ height: '60px', marginTop: '20px', marginLeft: '10px' }}><small className="titulo_compra_baja">{traducirPagina("nextdata_historial_baja")}</small> <div className="fecha_compra_baja">{`${registro.FECHA_BAJA}`}</div> </div> })
                    }

                    if (registro.FECHA_ALTA !== "") {
                        LISTA_FINAL.push({ position: 'right', dot: <ShoppingOutlined style={{ fontSize: '30px', color: '#4285f4' }} />, children: <div style={{ marginTop: '20px', marginRight: '10px' }}><small className="titulo_compra_data">{traducirPagina("nextdata_historial_alta")}</small> <div className="fecha_compra_data">{`${registro.FECHA_ALTA}`}</div></div> })

                    }

                    if (i === DATA.length - 1) {
                        LISTA_FINAL.push({ dot: <ClockCircleOutlined style={{ fontSize: '18px', color: '#4285f4' }} />, children: "" })
                    }
                })
            }
        }

        return LISTA_FINAL

    }


    return <>
        <Drawer
            width={500}
            onClose={() => { props.ESTADO.ABRIR_FICHA = false; props.setEstado({ ...props.ESTADO }) }}
            visible={props.ESTADO.ABRIR_FICHA}
            closable={false}
            placement={"right"}
            bodyStyle={{ padding: '0px' }}
            style={{ color: '#fff' }}>


            <div className='containerHeaderDrawer'>
                <div className='itemHeaderDrawer1'>
                    <CloseOutlined onClick={(e) => {
                        props.ESTADO.ABRIR_FICHA = false; props.setEstado({ ...props.ESTADO })
                    }}></CloseOutlined >
                    <div> {props.title}</div>
                </div>

                <div className='itemHeaderDrawer2'>

                </div>
            </div>


           


            <div className="containerHistorial">
                {props.LISTA === null ?
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', height: '100%' }}>
                        <h4>{traducirPagina("Sin_registros")}</h4>
                    </div> :

                    props.LISTA.length === 0 ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', height: '100%' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>


                        :
                        <Timeline
                            mode="alternate"
                        >
                            {CREAR_LISTA(props.LISTA).map((registro, i) =>
                                registro.dot &&
                                <Timeline.Item dot={registro.dot} position={registro.position}>
                                    {registro.children}
                                </Timeline.Item>
                            )}
                        </Timeline>
                }

            </div>
        </Drawer>
    </>;
};